import React from "react";
import Typography from "@mui/material/Typography";
import { textCut } from "@assets/utils/check";
import PropTypes from "prop-types";

/**
 * 제목 : 광고주 / 광고상품 / 이미지 메뉴얼
 * 참고 Url : https://mui.com/material-ui/react-avatar/#main-content
 * params :
 *  alt : 이미지 설명
 *  src : 이미지 url
 *  width : 이미지 넓이
 *  height: 이미지 높이
 */
const MenuCaseView = ({
  value,
  adType = "ad",
  text = "광고상품 전체",
  adFunc = null,
  imgName = "이미지명 없음",
  cut = 999,
  width = "auto",
}) => {
  const adCaseView = (adType = "ad") => {
    switch (adType) {
      case "ad":
        return value === 0 ? text : textCut(adFunc(), cut);
      case "advertiser":
        return value === 0 ? text : textCut(adFunc(), cut);
      case "img":
        return value === null ? text : textCut(imgName, cut);
      default:
        return value === 0 ? text : textCut("정보없음", cut);
    }
  };
  return (
    <Typography
      textAlign="center"
      variant="body"
      component="div"
      fontWeight={400}
      width={width}
    >
      {adCaseView(adType)}
    </Typography>
  );
};

MenuCaseView.propTypes = {
  value: PropTypes.number || null,
  adType: PropTypes.string,
  text: PropTypes.string,
  adFunc: PropTypes.func || null,
  imgName: PropTypes.string,
  cut: PropTypes.number,
};

export default MenuCaseView;
